"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getComponentParents = void 0;
/** 获取 组件 祖宗列表
 * @description: 获取 component 元素的祖宗列表，返回一个数组，数组是当前 component 元素的族谱
 * @param { Object }  component  目标 component
 * @param { Array | String } field 获取指定组件的 tag
 * @return { Array }  component  的族谱
 */
var getComponentParents = exports.getComponentParents = function getComponentParents(component) {
  var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  // eslint-disable-next-line no-underscore-dangle
  if (!component._isVue) return null;
  var arr = [component];

  // eslint-disable-next-line no-underscore-dangle
  while ((_arr$ = arr[0]) !== null && _arr$ !== void 0 && _arr$._isVue && arr[0].$parent && arr[0].$options._componentTag !== field) {
    var _arr$;
    arr.unshift(arr[0].$parent);
  }
  return field ? arr[0] : arr;
};